
import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { SidebarHeader as Header } from "@/components/ui/sidebar";
import { Button } from "@/components/ui/button";
import Icon from "@/components/ui/icon";
import { useIsMobile } from "@/hooks/use-mobile";
import SearchInput from "./SearchInput";
import { TooltipProvider } from "@/components/ui/tooltip";

const SidebarHeader = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const [isLoaded, setIsLoaded] = useState(false);
  
  const isFocusedPage = location.pathname.startsWith('/content/');

  useEffect(() => {
    setIsLoaded(true);
    console.log("SidebarHeader loaded, current path:", location.pathname);
  }, [location.pathname]);

  const handleBack = () => {
    console.log("Back button clicked, navigating to previous page");
    navigate(-1);
  };

  if (!isLoaded) {
    return (
      <Header className="flex flex-col p-0 relative h-[112px]">
        <div className="flex items-center justify-center h-[80px]">
          <div className="h-[54px] w-[180px] bg-gray-100 animate-pulse rounded-md"></div>
        </div>
        <div className="px-3 h-8">
          <div className="w-full h-8 bg-gray-100 animate-pulse rounded-md"></div>
        </div>
      </Header>
    );
  }

  return (
    <TooltipProvider>
      <Header className="flex flex-col p-0 relative h-[112px]">
        <div className="flex items-center justify-between h-[80px] pl-3 pr-3" style={{ height: '80px' }}>
          <Link to="/dashboard" className="flex items-center">
            <img 
              src="/lovable-uploads/cd802131-cee6-4c40-bc8c-00e47c647d9a.png" 
              alt="Clustr Logo" 
              className="h-[54px]" 
              style={{ height: '54px', width: 'auto' }}
              onError={(e) => {
                console.error("Logo failed to load");
                e.currentTarget.src = "/lovable-uploads/538dfb2b-93c1-451f-9a81-7393dd3964c9.png";
              }}
            />
          </Link>
          
          {isFocusedPage && !isMobile && (
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={handleBack}
              className="rounded-full h-8 w-8 hover:bg-white/10"
            >
              <Icon icon={ArrowLeft} size={16} color="#6B7789" />
            </Button>
          )}
        </div>
        
        <div className="px-3 h-8">
          <SearchInput />
        </div>
      </Header>
    </TooltipProvider>
  );
};

export default SidebarHeader;
